
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiHeavySnowShowersDay as ObiHeavySnowShowersDayElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-heavy-snow-showers-day.js';
 
 
 

 
 export const ObiHeavySnowShowersDay = createComponent({
   react: React,
   tagName: 'obi-heavy-snow-showers-day',
   elementClass: ObiHeavySnowShowersDayElement,
   events: {
     
   }
  });
 
 